import React,{ useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillFacebook,
  AiFillInstagram,
} from "react-icons/ai";

function Footer() {
  const [count, setCount] = useState(0);
  useEffect(() => {
  const storedCount = localStorage.getItem("pageVisits");
  const initialCount = storedCount ? Number(storedCount) : 0;
  setCount(initialCount + 1);
  localStorage.setItem("pageVisits", initialCount + 1);
  }, []);
  let date = new Date();
  let year = date.getFullYear();

  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
         <p style={{ color:'#0a0416'}}>.{count}  </p>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright ©{year} Vijay Anna - Voice of Tamil People</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            
            <li className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61568597873787"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillFacebook />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61568597873787"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}
export default Footer;
